import hasClass from './hasClass';
function addClass(el, className) {
    if (el.classList)
        el.classList.add(className);
    else if (!hasClass(el, className))
        el.className += ' ' + className;
}
export default addClass;
//# sourceMappingURL=addClass.js.map